import React from 'react';

import TableRow from './TableRow.jsx';

const TableBody = (props) => {
    let oProfiles = props.perfiles.map(function (perfil) {       
        if ((perfil.ProductoId == null) || (props.filter.product == 0) ||(perfil.ProductoId == props.filter.product)) {
            return (
                <TableRow activate={props.filter.activate}
                    perfil={perfil}
                    key={"ProfRow_" + perfil.Id}
                    functions={props.functions}
                    setPerfilEdicion={props.setPerfilEdicion}
                    setInfoPerfilToDelete={props.setInfoPerfilToDelete} />
            );
        }
    });

    return (
        <tbody>
            {oProfiles}
        </tbody>
    );
}

export default TableBody;